/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function ChevronUpIcon(props: IconProps) {
    return <IconWrapper {...props}>{<path d="M19.462 13.421a1.47 1.47 0 0 1 2.06 0L33.579 25.41c.563.624.563 1.56 0 2.123-.624.624-1.561.624-2.123 0L20.523 16.606 9.593 27.532c-.625.624-1.562.624-2.125 0a1.367 1.367 0 0 1 0-2.06z"/>}</IconWrapper>;
}
